export default __webpack_public_path__ + "static/media/person_icon_white.e269bf34.svg";